module.exports = __webpack_public_path__ + "static/healthcare-background-c7f6ce7467e75c40107b3d4492d5e37c.jpg";